import React from "react";
import {
  toWSDateString,
  WSElement,
  WSList,
  WSPanel,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import {
  RequirementAdditionalData,
  RequirementContextType,
  RequirementTableItemData
} from "../types";
import { useRequirementsConfig } from "../useRequirementsConfig";
import {
  IPayeeResponse,
  IPayerResponse
} from "@wingspanhq/payments/dist/interfaces";
import { useGeneralRequirementsConfig } from "../modules/GeneralRequirements/useGeneralRequirementsConfig";
import { ExtendedRequirementItem } from "../modules/GeneralRequirements/types";
import { DataViewGrid } from "../../../shared/components/DataView";

type RequirementPreviewListProps = {
  requirements: Array<ExtendedRequirementItem>;
  payee?: IPayeeResponse;
  payer?: IPayerResponse;
  payerId: string | undefined;
  payeeId: string | undefined;
  contextType: RequirementContextType;
  getOnViewDetails: (
    item: ExtendedRequirementItem,
    additionalData?: RequirementAdditionalData
  ) => ((item: RequirementTableItemData) => void) | undefined;
};

export const ExtendedRequirementPreviewList: React.FC<
  RequirementPreviewListProps
> = ({
  requirements,
  payee,
  payer,
  payerId,
  payeeId,
  contextType,
  getOnViewDetails
}) => {
  const generalRequirementsConfig = useGeneralRequirementsConfig({
    payee,
    payer,
    payerId,
    payeeId,
    contextType
  });

  const requirementsConfig = useRequirementsConfig({
    requirements: requirements.filter(
      requirement => "requirementId" in requirement
    ) as RequirementTableItemData[],
    contextType
  });

  return (
    <WSList>
      {requirements.map((requirement, index) => (
        <WSPanel key={requirement.requirementType + index}>
          {"requirementId" in requirement ? (
            <WSList gap="M">
              <WSElement>
                <WSSectionToolbar
                  title={
                    requirementsConfig.getNameCellProps(requirement).text || ""
                  }
                  mb="NONE"
                  button={{
                    label: "View",
                    onClick: () =>
                      getOnViewDetails(
                        requirement,
                        requirementsConfig.getAdditionalData(requirement)
                      )?.(requirement)
                  }}
                  actions={requirementsConfig.getToolbarActions(requirement)}
                />
                <WSText.ParagraphXs color="gray500">
                  Updated at {toWSDateString(requirement.updatedAt)}
                </WSText.ParagraphXs>
              </WSElement>
              <DataViewGrid
                gridColumns={3}
                data={
                  requirementsConfig.getRequirementBasicInformation(
                    requirement
                  ) || []
                }
              />
              {requirementsConfig.getRequirementDetailsProgressWidget(
                requirement,
                false
              )}
            </WSList>
          ) : (
            <WSList gap="M">
              <WSElement>
                <WSSectionToolbar
                  title={
                    generalRequirementsConfig.getNameCellProps(requirement).text
                  }
                  mb="NONE"
                  actions={generalRequirementsConfig.getRowMenuActions(
                    requirement
                  )}
                />
                {/*
                <WSText.ParagraphXs color="gray500">
                  Updated at {"TODO"}
                </WSText.ParagraphXs>
                */}
              </WSElement>
              <DataViewGrid
                gridColumns={3}
                data={[
                  {
                    label: "Type",
                    value:
                      generalRequirementsConfig.getTypeCellProps(requirement)
                        .text,
                    icon: generalRequirementsConfig.getTypeCellProps(
                      requirement
                    ).icon
                  },
                  {
                    label: "Engagements",
                    value:
                      generalRequirementsConfig.getEngagementsCellProps(
                        requirement
                      ).text
                  },
                  {
                    label: "Status",
                    hideValue: true,
                    pill: generalRequirementsConfig.getStatusCellProps(
                      requirement
                    ).pill
                  }
                ]}
              />
            </WSList>
          )}
        </WSPanel>
      ))}
    </WSList>
  );
};
